module.exports = __webpack_public_path__ + "img/promotions-promotion.9743a742.svg";